export const DEFAULT_BOOKMARK_STATUS = 'planning';
export const DEFAULT_BOOKMARK_STATUS_MODE = 'automatic';

export const BOOKMARK_STATUS_OPTIONS = Object.freeze([
    { value: 'planning', label: 'Plan to Watch' },
    { value: 'watching', label: 'Watching' },
    { value: 'completed', label: 'Completed' },
    { value: 'on_hold', label: 'On Hold' },
    { value: 'dropped', label: 'Dropped' }
]);

const BOOKMARK_STATUS_VALUES = new Set(
    BOOKMARK_STATUS_OPTIONS.map((option) => option.value)
);
const BOOKMARK_STATUS_MODE_VALUES = new Set(['automatic', 'manual']);

export function normalizeBookmarkStatus(value = '') {
    const normalized = `${value || ''}`.trim().toLowerCase();
    return BOOKMARK_STATUS_VALUES.has(normalized)
        ? normalized
        : DEFAULT_BOOKMARK_STATUS;
}

export function getBookmarkStatusLabel(value = '') {
    const normalized = normalizeBookmarkStatus(value);
    return BOOKMARK_STATUS_OPTIONS.find((option) => option.value === normalized)?.label
        || BOOKMARK_STATUS_OPTIONS[0].label;
}

export function normalizeBookmarkStatusMode(value = '', status = DEFAULT_BOOKMARK_STATUS) {
    const normalized = `${value || ''}`.trim().toLowerCase();
    if (BOOKMARK_STATUS_MODE_VALUES.has(normalized)) {
        return normalized;
    }
    const normalizedStatus = normalizeBookmarkStatus(status);
    return normalizedStatus === DEFAULT_BOOKMARK_STATUS
        ? DEFAULT_BOOKMARK_STATUS_MODE
        : 'manual';
}

export function buildBookmarkStatusMap(entries = [], animeIds = []) {
    const statuses = {};

    (Array.isArray(animeIds) ? animeIds : []).forEach((value) => {
        const animeId = Number.parseInt(value, 10);
        if (Number.isInteger(animeId)) {
            statuses[animeId] = DEFAULT_BOOKMARK_STATUS;
        }
    });

    (Array.isArray(entries) ? entries : []).forEach((entry) => {
        const animeId = Number.parseInt(
            entry?.anime_id ?? entry?.animeId ?? entry?.id,
            10
        );
        if (Number.isInteger(animeId) && Object.prototype.hasOwnProperty.call(statuses, animeId)) {
            statuses[animeId] = normalizeBookmarkStatus(entry?.status);
        }
    });

    return statuses;
}

export function buildBookmarkStatusModeMap(entries = [], animeIds = []) {
    const modes = {};

    (Array.isArray(animeIds) ? animeIds : []).forEach((value) => {
        const animeId = Number.parseInt(value, 10);
        if (Number.isInteger(animeId)) {
            modes[animeId] = DEFAULT_BOOKMARK_STATUS_MODE;
        }
    });

    (Array.isArray(entries) ? entries : []).forEach((entry) => {
        const animeId = Number.parseInt(
            entry?.anime_id ?? entry?.animeId ?? entry?.id,
            10
        );
        if (Number.isInteger(animeId) && Object.prototype.hasOwnProperty.call(modes, animeId)) {
            modes[animeId] = normalizeBookmarkStatusMode(entry?.status_mode, entry?.status);
        }
    });

    return modes;
}
